import React from 'react';

import { WhatWeTreat } from '.';
import type { WhatWeTreatEntry } from 'schema';
import { SmartImage } from 'components/global/SmartImage';

export const ContentfulWhatWeTreat = ({
  glyphs,
  ...props
}: WhatWeTreatEntry) => (
  <WhatWeTreat
    glyphs={glyphs.map(({ header, media }) => ({
      name: header,
      glyph: <SmartImage {...media} loading="lazy" />,
    }))}
    {...props}
  />
);
